"use strict";

require("core-js/modules/es.date.to-string.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customEventPolyfill = customEventPolyfill;
exports.torchTrack = torchTrack;
exports.uuidv4 = uuidv4;

var _constants = require("./constants");

function customEventPolyfill() {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
}

function torchTrack(payload, stage) {
  if (typeof window === 'undefined') {
    return;
  }

  var torchUrl = stage === _constants.STAGES.PROD ? 'https://torch.buyerzone.com/prod/event' : 'https://torch.buyerzone.com/test/event'; // convert payload to query string in IE compatible way

  var UrlParams = Object.keys(payload).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(payload[k]);
  }).join('&');
  var xhr = new XMLHttpRequest();
  xhr.open('GET', "".concat(torchUrl, "?").concat(UrlParams), true);
  xhr.withCredentials = true;
  xhr.send(null);
} // simple implementation from here: https://stackoverflow.com/questions/105034/how-to-create-guid-uuid


function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}